import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

type InfoIconClass = 'ava-info-icon' | 'wallpaper-info-icon'
type ContentClass = 'ava-content' | 'wallpaper-content'

@Component({
  selector: 'bmcore-wallpaper-tooltip',
  templateUrl: './bmcore-wallpaper-tooltip.component.html',
  styleUrls: ['./bmcore-wallpaper-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreWallpaperTooltipComponent {
  @Input() text: string = ''
  @Input() infoIconClass: InfoIconClass
  @Input() contentClass: ContentClass

  isTooltipOpen = false

  tooltipHandler() {
    this.isTooltipOpen = !this.isTooltipOpen
  }
}
